// @ts-nocheck
import logger from "@insite/client-framework/Logger";
import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { ContentSearchPagesCollectionModel } from "@store/Framework/Types/ApiModels";

const contentUrl = "/api/v2/content";

export interface GetContentSearchApiParameter extends ApiParameter {
    cpage?: number;
    cpageSize?: number;
    currentTab?: string;
    query?: string;
}

export const getContentSearch = async (parameter: GetContentSearchApiParameter) => {
    let pages: ContentSearchPagesCollectionModel = {
        pages: [],
        pagination: {} as any,
        uri: "",
        properties: {},
    };

    try {
        pages = await get<ContentSearchPagesCollectionModel>(contentUrl, {
            query: parameter.query,
            page: parameter.cpage,
            pageSize: parameter.cpageSize,
        } as any);
    } catch (error) {
        logger.warn(`Failed to load content search pages: ${error.errorMessage}`);
    }

    return pages;
};
